Number.prototype.radix = function (to: number): number[] {
  const result = [];
  const me: number = this.valueOf();
  let quotient = Math.floor(me / to);
  const remainder = me % to;
  result.push(remainder);
  while (quotient >= to) {
    result.push(quotient % to);
    quotient = Math.floor(quotient / to);
  }
  if (quotient > 0) {
    result.push(quotient);
  }
  return result.reverse();
};
